import { CHANGE_ATWATER_INFO_VALUE, RESET_STATE_ATWATER } from './actionTypes';

export const changeAtWaterInfoValue = (key, value) => ({
  type: CHANGE_ATWATER_INFO_VALUE,
  key,
  value,
});

export const resetAtWaterState = () => ({ type: RESET_STATE_ATWATER });
